<template>
  <div>
    <div
      id="layout"
      style="visibility: visible;"
    >
      <header-info cur="100"></header-info>
      <div
        id="center"
        class="center_box"
      >
        <div
          id="main"
          class="main clearfix"
        >
          <div
            id="leftmenu"
            class="leftmenu"
          >
            <div class="leftmenu-item">
              <p class="p1">个人设置</p>
              <ul class="leftmenu-list">
                <li
                  class="li1"
                  :class="menuSelected == '/admin/profile' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link to="/admin/profile"><i class="iconfont"></i>我的信息
                  </router-link>
                </li>
                <li
                  class="li2"
                  :class="menuSelected == '/admin/password' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link to="/admin/password"><i class="iconfont"></i>修改密码
                  </router-link>
                </li>
              </ul>
            </div>
            <div
              class="leftmenu-item"
              v-if="localUser.role != 10"
            >
              <p class="p1">我的学习</p>
              <ul class="leftmenu-list">
                <li
                  class="li3"
                  :class="menuSelected == '/admin/my_experiment' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link to="/admin/my_experiment"><i class="iconfont"></i>我的实验</router-link>
                </li>
                <li
                  class="li3"
                  :class="menuSelected == '/admin/my_lesson' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link to="/admin/my_lesson"><i class="iconfont"></i>我的课程</router-link>
                </li>
                <li
                  class="li4"
                  :class="menuSelected == '/admin/my_collection' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link to="/admin/my_collection"><i class="iconfont"></i>我的收藏</router-link>
                </li>
                <li
                  class="li5"
                  :class="menuSelected == '/admin/my_appraise' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link to="/admin/my_appraise"><i class="iconfont"></i>我的评价</router-link>
                </li>
                <li
                  class="li5"
                  :class="menuSelected == '/admin/my_message' ? 'on' : '' "
                  @click="updateMenuSelected"
                >
                  <router-link
                    :class="messageCount? 'messagenum' : ''"
                    to="/admin/my_message"
                  ><i class="iconfont"></i>我的消息</router-link>
                </li>
              </ul>
            </div>
            <div
              class="leftmenu-item"
              v-if="localUser.role != 12"
            >
              <p class="p1">后台管理</p>
              <ul class="leftmenu-list">
                <li
                  class="li6"
                  :class="menuSelected == '/admin/user' ? 'on' : ''"
                  @click="updateMenuSelected"
                  v-if="[0, 2, 3, 4, 11].indexOf(localUser.role) >= 0"
                >
                  <router-link to="/admin/user"><i class="iconfont"></i>用户管理</router-link>
                </li>
                <li
                  class="li7"
                  v-if="localUser.role == 0"
                  :class="menuSelected == '/admin/school' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link to="/admin/school"><i class="iconfont"></i>学校管理</router-link>
                </li>
                <li
                  class="li7"
                  v-if="localUser.role == 0 || (platform_level == 3 && localUser.role == 3)|| (platform_level == 4 && localUser.role == 4)"
                  :class="menuSelected == '/admin/academy' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link to="/admin/academy"><i class="iconfont"></i>院系机构管理</router-link>
                </li>
                <li
                  class="li8"
                  v-if="localUser.role == 0 || (platform_level == 3 && localUser.role == 3)|| (platform_level == 4 && localUser.role == 4)"
                  :class="menuSelected == '/admin/major' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link to="/admin/major"><i class="iconfont"></i>专业分类管理</router-link>
                </li>
                <li
                  class="li9"
                  :class="menuSelected == '/admin/experiment' ? 'on' : ''"
                  @click="updateMenuSelected"
                  v-if="[0, 2, 3, 4].indexOf(localUser.role) >= 0"
                >
                  <router-link to="/admin/experiment"><i class="iconfont"></i>实验管理</router-link>
                </li>
                <li
                  class="li9"
                  v-if="localUser.role == 11"
                  :class="menuSelected == '/admin/experimentTeacher' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link to="/admin/experimentTeacher"><i class="iconfont"></i>实验管理</router-link>
                </li>
                <li
                  class="li9"
                  :class="menuSelected == '/admin/affirm' ? 'on' : ''"
                  @click="updateMenuSelected"
                  v-if="[0, 2, 3, 4].indexOf(localUser.role) >= 0"
                >
                  <router-link to="/admin/affirm"><i class="iconfont"></i>认定管理</router-link>
                </li>
                <li
                  class="li9"
                  :class="menuSelected == '/admin/lesson' ? 'on' : ''"
                  @click="updateMenuSelected"
                  v-if="[0, 2, 3, 4, 11].indexOf(localUser.role) >= 0"
                >
                  <router-link to="/admin/lesson"><i class="iconfont"></i>课程管理</router-link>
                </li>
                <li
                  class="li10"
                  v-if="[0, 10].indexOf(localUser.role) >= 0 || (platform_level == 3 && localUser.role == 3)|| (platform_level == 4 && localUser.role == 4)"
                  :class="menuSelected == '/admin/info' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link to="/admin/info"><i class="iconfont"></i>资讯管理</router-link>
                </li>
                <li
                  class="li11"
                  v-if="[0, 10].indexOf(localUser.role) >= 0 || (platform_level == 3 && localUser.role == 3)|| (platform_level == 4 && localUser.role == 4)"
                  :class="menuSelected == '/admin/flash' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link to="/admin/flash"><i class="iconfont"></i>轮播图管理</router-link>
                </li>
                <li
                  class="li11"
                  v-if="[0, 10].indexOf(localUser.role) >= 0 || (platform_level == 3 && localUser.role == 3)|| (platform_level == 4 && localUser.role == 4)"
                  :class="menuSelected == '/admin/station/research' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link to="/admin/station/research"><i class="iconfont"></i>问卷调查管理</router-link>
                </li>
                <li
                  v-if="[0, 10].indexOf(localUser.role) >= 0 || (platform_level == 3 && localUser.role == 3)|| (platform_level == 4 && localUser.role == 4)"
                  class="li11"
                  :class="menuSelected == '/admin/feedback' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link to="/admin/feedback"><i class="iconfont"></i>意见反馈管理</router-link>
                </li>
                <li
                  v-if="[0].indexOf(localUser.role) >= 0 || (platform_level == 3 && localUser.role == 3)|| (platform_level == 4 && localUser.role == 4)"
                  class="li11"
                  :class="menuSelected == '/admin/log' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link to="/admin/log"><i class="iconfont"></i>日志管理</router-link>
                </li>
                <li
                  v-if="[0, 10].indexOf(localUser.role) >= 0 || (platform_level == 3 && localUser.role == 3)|| (platform_level == 4 && localUser.role == 4)"
                  class="li11"
                  :class="menuSelected == '/admin/message' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link to="/admin/message"><i class="iconfont"></i>消息管理</router-link>
                </li>
              </ul>
            </div>
          </div>
          <div id="panel-wrap">
            <router-view></router-view>
          </div>
        </div>
      </div>
      <div id="south">
        <footer-info></footer-info>
      </div>
    </div>
    <div
      id="dialog_overlay"
      :style="showMsgWindow"
    >
      <div id="dialog_bg"></div>
      <div
        id="dialog_panel"
        style="margin-left: -136px; margin-top: -54px;max-width: 300px;"
      >
        <div id="dialog_panel_bg"></div>
        <div id="dialog_title">提示</div>
        <div id="dialog_content">{{ msgText }}</div>
        <div id="dialog_content2">
          <span
            v-for="item in errorList"
            v-bind:key="item"
          >{{ item }}</span>
        </div>
        <div id="dialog_control">
          <a
            href="javascript:void(0)"
            id="dialog_close"
            @click="hideMsg"
            class="button"
            :style="this.msgType == 1? 'display:inline-block': 'display:none'"
          >取消</a>
          <a
            href="javascript:void(0)"
            id="dialog_ok"
            @click="confirmMsg"
            :class="this.msgType == 1? 'button': 'button col2'"
            :style="this.msgType == 2? 'display:none': 'display: inline-block'"
          >确认</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import HeaderInfo from '../../components/HeaderInfo'
import FooterInfo from '../../components/FooterInfo'

export default {
  name: 'Layout',
  components: {
    HeaderInfo,
    FooterInfo
  },

  data: function () {
    return {
      menuSelected: '',
      showMsgWindow: {},
      msgText: '',
      msgType: 0,
      errorList: [],
      messageCount: 0
    }
  },
  methods: {
    updateMenuSelected() {
      const url = window.location.href
      const arrUrl = url.split('//')
      const start = arrUrl[1].indexOf('/')
      let relUrl = arrUrl[1].substring(start)

      if (relUrl.indexOf('?') !== -1) {
        relUrl = relUrl.split('?')[0]
      }
      relUrl = relUrl.replace('#', '')
      this.menuSelected = relUrl
    },
    showMsg(text, callback = '') {
      this.msgType = 0
      this.msgText = text
      this.showMsgWindow = {
        visibility: 'visible'
      }
      this.confirmCallback = callback
    },
    showConfirm(text, callback) {
      this.msgType = 1
      this.msgText = text
      this.showMsgWindow = {
        visibility: 'visible'
      }
      this.confirmCallback = callback
    },
    pushError(err) {
      this.errorList.push(err)
    },
    hideMsg() {
      this.msgText = ''
      this.showMsgWindow = {}
    },
    confirmMsg() {
      this.msgText = ''
      this.showMsgWindow = {}
      if (this.confirmCallback) {
        this.confirmCallback()
        this.confirmCallback = ''
      }
    },
    async getMessageCount() {
      await this.$http.get('/user_message_count/', {
        params: {
          userprofile_id: this.$store.state.userInfo.profile_id
        }
      }).then((data) => {
        this.messageCount = data.data
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  mounted() {
    this.updateMenuSelected()
    this.getMessageCount()
  },
  // 计算属性
  computed: {
    localUser() {
      return this.$store.state.userInfo
    },
    platform_level() {
      return this.$store.state.platform_level
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/dialog.css";
@import "../../assets/css/common.css";

@import "../../assets/css/pagination.css";
@import "../../assets/css/form.css";
@import "../../assets/css/panel.css";

@import "../../assets/css/leftmenu.css";

.messagenum {
  position: relative;
}
.messagenum::before {
  content: "";
  display: block;
  width: 7px;
  height: 7px;
  background: red;
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 50%;
}
</style>
